import React, { useContext, useEffect } from "react";
import { Card, Input, Button, Modal } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
  url: Yup.string().url("URL inválida").required("Campo obrigatório"),
});

function FieldUrl(props) {
  const {
    isModalOpen,
    onCancel,
    content,
    formOrTaskId,
    onSubmit,
    placeholder = "Digite a URL",
  } = props;

  const formik = useFormik({
    initialValues: {
      url: content ?? "",
    },
    validationSchema,
    validateOnChange: true,
    enableReinitialize: true,
    validateOnBlur: true,
    onSubmit: (values) => {
      const url = values.url;
      onSubmit(url, formOrTaskId);
    },
  });

  const borderColor = formik.touched.url
    ? formik.errors.url
      ? "2px solid #ff4d4f"
      : "2px solid #52c41a"
    : undefined;

  return (
    <div>
      <Modal
        open={isModalOpen}
        onCancel={onCancel}
        footer={[
          <div className="w-100 justify-content-center d-flex" key="footer">
            <Button
              style={{
                borderRadius: "5px",
                width: "150px",
                fontSize: "1rem",
              }}
              className="btn-default"
              onClick={formik.handleSubmit}
            >
              Salvar
            </Button>
          </div>,
        ]}
      >
        <div className="row mt-4">
          <div className="d-flex w-100">
            <div className="col-sm-8 col-md-8 col-lg-12">
              <Input
                id="url"
                name="url"
                placeholder={placeholder}
                value={formik.values.url}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                onPressEnter={formik.handleSubmit}
                onFocus={(e) => e.target.select()}
                style={{
                  borderRadius: "5px",
                  border: borderColor,
                }}
                bordered
              />
              {formik.touched.url && formik.errors.url && (
                <div style={{ color: "#ff4d4f", marginTop: 5 }}>
                  {formik.errors.url}
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default FieldUrl;
